import { Call } from "../api/models/Call";
import { UiModal } from "../components/Modals/UiModals";

export type ChatActionTypes = SetSessionId | SetParticipants | SetExistingParticipants | SetNewParticipant | SetPeer | SetNewMessagesCount | ReadMessage;

export const SET_SESSION_ID = 'SET_SESSION_ID';
export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
export const SET_EXISTING_PARTICIPANTS = 'SET_EXISTING_PARTICIPANTS';
export const SET_NEW_PARTICIPANT = 'SET_PARTICIPANT';
export const SET_PEER = 'SET_PEER';
export const SET_NEW_MESSAGES_COUNT = 'SET_NEW_MESSAGES_COUNT';
export const READ_MESSAGE = 'READ_MESSAGE';

interface SetSessionId {
    type: typeof SET_SESSION_ID,
    sessionId: string
}

interface SetParticipants {
    type: typeof SET_PARTICIPANTS,
    participants: any
}

interface SetExistingParticipants {
    type: typeof SET_EXISTING_PARTICIPANTS,
    existingParticipants: any
}

interface SetNewParticipant {
    type: typeof SET_NEW_PARTICIPANT,
    newParticipant: any
}

interface SetPeer {
    type: typeof SET_PEER,
    webRtcPeer: any
}

interface SetNewMessagesCount {
    type: typeof SET_NEW_MESSAGES_COUNT,
    newMessagesCount: any
}

interface ReadMessage {
    type: typeof READ_MESSAGE
}

export type PageActionTypes = SetPage | SetParams;

export const SET_PAGE = 'SET_PAGE';
export const SET_PARAMS = 'SET_PARAMS';

interface SetPage {
    type: typeof SET_PAGE,
    currentPage: string,
    params?: any;
}

interface SetParams {
    type: typeof SET_PARAMS,
    params: any
}

export type OnlineActionTypes = SetUsers | AddUser | RemoveUser | AddIncommingCall | RemoveIncommingCall | AddCall | RemoveCall;

export const SET_USERS = 'SET_USERS';
export const ADD_USER = 'ADD_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const ADD_INCOMMING_CALL = 'ADD_INCOMMING_CALL';
export const REMOVE_INCOMMING_CALL = 'REMOVE_INCOMMING_CALL';
export const ADD_CALL = 'ADD_CALL';
export const REMOVE_CALL = 'REMOVE_CALL';

interface SetUsers {
    type: typeof SET_USERS,
    users: string[]
}

interface AddUser {
    type: typeof ADD_USER,
    user: string
}

interface RemoveUser {
    type: typeof REMOVE_USER,
    user: string
}

interface AddIncommingCall {
    type: typeof ADD_INCOMMING_CALL,
    incommingCall: Call
}

interface RemoveIncommingCall {
    type: typeof REMOVE_INCOMMING_CALL,
}

interface AddCall {
    type: typeof ADD_CALL,
    call: Call
}

interface RemoveCall {
    type: typeof REMOVE_CALL,
}


export type ModalActionTypes =
    AddModal | RemoveModal | ClearModal;

export const ADD_MODAL = 'ADD_MODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';
export const CLEAR_MODAL = 'CLEAR_MODAL';

export interface AddModal {
    type: typeof ADD_MODAL,
    modal: UiModal
}

export interface RemoveModal {
    type: typeof REMOVE_MODAL,
    modal: UiModal
}

export interface ClearModal {
    type: typeof CLEAR_MODAL
}